import { render, staticRenderFns } from "./Lab-update.vue?vue&type=template&id=4b4cfe6a&scoped=true"
import script from "./Lab-update.js?vue&type=script&lang=js&external"
export * from "./Lab-update.js?vue&type=script&lang=js&external"
import style0 from "./Lab-update.vue?vue&type=style&index=0&id=4b4cfe6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4cfe6a",
  null
  
)

export default component.exports